import { Link } from '@mui/material';
import { Link as RouterLink } from 'react-router';

interface SecondaryBarLinkProps {
  to: string;
  active?: boolean;
  children: React.ReactNode;
}

export default function SecondaryBarLink({
  to,
  active = false,
  children,
}: Readonly<SecondaryBarLinkProps>) {
  return (
    <Link
      component={RouterLink}
      variant='h6'
      underline='hover'
      to={to}
      sx={{
        whiteSpace: 'nowrap',
        lineHeight: '150%',
        paddingX: 0,
        paddingY: 0.5,
        fontSize: '0.875rem !important',
        fontWeight: 600,
        color: active ? 'primary.main' : 'text.secondary',
      }}
    >
      {children}
    </Link>
  );
}
